var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { DEFAULT_LEAKAGE_CAUSE_LOCATIONS, LEAKAGE_CAUSE_LOCATIONS_BY_HOUSING_TYPE, } from '@shared/constants/waterDamageConstants';
import { LEAKAGE_CAUSE_LOCATION_OPTIONS } from '@declaration/constants/waterDamageConstants';
import { LeakageCauseLocation } from '@shared/types/api/claim';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const contract = namespace('contract');
const settings = namespace('settings');
let LeakageCauseLocationQuestion = class LeakageCauseLocationQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.firstTimeAsked = true;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    mounted() {
        if (this.waterDamageQualification.leakageCauseLocation) {
            this.firstTimeAsked = false;
        }
    }
    async updateClaim(leakageCauseLocation) {
        await this.updateAndSaveWaterDamageQualification({
            qualificationPayload: {
                leakageCauseLocation,
                leakageCauseLocationHouse: null,
                leakageCauseDetailSlug: null,
                leakageCauseEquipmentSlug: null,
                leakageCauseRoomSlug: null,
            },
            step: this.step,
        });
        this.firstTimeAsked = false;
    }
    get hideUnknownLeakageOption() {
        return insurerHasFeature(InsurerFeatureFlag.HideUnknownLeakageOption);
    }
    get leakageCauseLocationOptions() {
        var _a, _b, _c, _d, _e;
        let options;
        if (this.selectedContract === null) {
            options = DEFAULT_LEAKAGE_CAUSE_LOCATIONS.map((locationOption) => LEAKAGE_CAUSE_LOCATION_OPTIONS[locationOption]);
        }
        else {
            const causeLocations = LEAKAGE_CAUSE_LOCATIONS_BY_HOUSING_TYPE;
            const insurerCauseLocations = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.leakageCauseLocationsByHousingType) !== null && _d !== void 0 ? _d : null;
            if (insurerCauseLocations) {
                for (const location in causeLocations) {
                    if ((_e = insurerCauseLocations[location]) === null || _e === void 0 ? void 0 : _e.housingCapacity.includes(this.selectedContract.housingCapacity.code)) {
                        causeLocations[location] = insurerCauseLocations[location].leakageCauses;
                    }
                }
            }
            options = causeLocations[this.selectedContract.housingType.slug]
                ? causeLocations[this.selectedContract.housingType.slug].map((location) => LEAKAGE_CAUSE_LOCATION_OPTIONS[location])
                : DEFAULT_LEAKAGE_CAUSE_LOCATIONS.map((locationOption) => LEAKAGE_CAUSE_LOCATION_OPTIONS[locationOption]);
        }
        if (this.hideUnknownLeakageOption && !this.firstTimeAsked) {
            options = options.filter((option) => option.value !== LeakageCauseLocation.Unknown);
        }
        return options;
    }
    get choicesClass() {
        return this.selectedContract === null
            ? 'leakage-cause-location__choices'
            : `leakage-cause-location__choices leakage-cause-location__choices--${this.selectedContract.housingType.slug}`;
    }
    get panelTitle() {
        return this.$tc('claim.qualification.leakage_cause_location.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.leakage_cause_location.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (!this.waterDamageQualification.leakageCauseLocation) {
            return null;
        }
        return LEAKAGE_CAUSE_LOCATION_OPTIONS[this.waterDamageQualification.leakageCauseLocation]
            ? this.$tc(LEAKAGE_CAUSE_LOCATION_OPTIONS[this.waterDamageQualification.leakageCauseLocation]
                .answerTradKey)
            : null;
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.leakageCauseLocation) === null || _d === void 0 ? void 0 : _d.showHelpLink) === false) {
            return false;
        }
        return true;
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], LeakageCauseLocationQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], LeakageCauseLocationQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], LeakageCauseLocationQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], LeakageCauseLocationQuestion.prototype, "setting", void 0);
__decorate([
    contract.State('selectedContract')
], LeakageCauseLocationQuestion.prototype, "selectedContract", void 0);
LeakageCauseLocationQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], LeakageCauseLocationQuestion);
export default LeakageCauseLocationQuestion;
